/**
 * NOT opcode (0x19) - Bitwise NOT
 *
 * @param {import("../Frame/FrameType.js").BrandedFrame} frame - Frame instance
 * @returns {import("../Frame/FrameType.js").EvmError | null} Error if any
 */
export function handle(frame) {
	// Consume gas (GasFastestStep = 3)
	frame.gasRemaining -= 3n;
	if (frame.gasRemaining < 0n) {
		frame.gasRemaining = 0n;
		return { type: "OutOfGas" };
	}

	// Pop operand
	if (frame.stack.length < 1) return { type: "StackUnderflow" };
	const a = frame.stack.pop();
	if (a === undefined) return { type: "StackUnderflow" };

	// Bitwise NOT (mask to 256 bits)
	const result = ~a & ((1n << 256n) - 1n);

	// Push result
	if (frame.stack.length >= 1024) return { type: "StackOverflow" };
	frame.stack.push(result);

	// Increment PC
	frame.pc += 1;

	return null;
}
